import { createSelector } from 'reselect'

const consentSelector = state => state.get('consentLog')

export const getConsentLog = createSelector(
    consentSelector,
    consentImmutable => {
      const logs = consentImmutable.toJS()
      return logs.consentLogGet.log
    }
)
export const getCreateConsentLog = createSelector(
  consentSelector,
  consentImmutable => {
    const logs = consentImmutable.toJS()
    return logs.consentLogCreate
  }
)


// WEBPACK FOOTER //
// ./src/selectors/consent-log/consent-log-selector.js